import React from 'react'
import DeliverCostContainer from '../../../../Components/Deliver/DeliverCostContainer/DeliverCostContainer'
import Layout from '../../Layout'

const DeliverCost = () => {
  return (
    <Layout><DeliverCostContainer/></Layout>
  )
}

export default DeliverCost